import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { contentHeaders } from 'common/headers';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import {catchError} from 'rxjs/operators';


@Injectable()
export class LogsService extends BaseHttpService {

  rootUrl: string = 'items';

  fetch(brandId: string, itemId: any, page: number, itemsPerPage: number, rootUrl?: string): Observable<any> {
    return this.http.get(
      `${Config.API}/${rootUrl ? rootUrl : this.rootUrl}/${brandId}/${itemId}/logs?page=${page}&itemsPerPage=${itemsPerPage}`
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  rollback(brandId: string, itemId: any, rollbackId: any): Observable<any> {
    const body = JSON.stringify({rollbackId});
    return this.http.post(
      `${Config.API}/${this.rootUrl}/${brandId}/${itemId}/rollback`,
      body,
      {headers: contentHeaders}
    )

        .pipe(catchError(this.handleError.bind(this)));
  }

}
